import React from 'react';
import { useCompanyId } from '../../hooks/useCompanyId';
import { useDepartmentOwnerId } from '../../hooks/useDepartmentOwnerId';
import DepartmentCommunityWidget from '../community/DepartmentCommunityWidget';
import DepartmentRoadmap from './DepartmentRoadmap';
import DepartmentGoals from './DepartmentGoals';

// Community pillar id (lowercase) -> capitalized department key used by goals.
// Roadmap items use the lowercase pillar id directly (the `category` prop).
const DEPARTMENT_KEY = {
  sales: 'Sales',
  operations: 'Operations',
  technology: 'Technology',
  marketing: 'Marketing',
  finance: 'Finance',
  hr: 'HR',
};

/**
 * The shared top row for every department overview page:
 *   [ half-width Community ] [ quarter Roadmap progress ] [ quarter Goals ]
 * All three are filtered to the same department. Roadmap reads the COMPANY
 * roadmap (by companyId); goals read the account's primary-user goals (by ownerId).
 */
const DepartmentOverviewTopRow = ({ category, className = '', showGoals = true }) => {
  const { companyId, loading: companyLoading } = useCompanyId();
  const { ownerId, loading: ownerLoading } = useDepartmentOwnerId();
  const department = DEPARTMENT_KEY[category] || category;

  return (
    <div className={`grid grid-cols-1 ${showGoals ? 'lg:grid-cols-4' : 'lg:grid-cols-3'} gap-6 mb-6 ${className}`}>
      <DepartmentCommunityWidget category={category} className="lg:col-span-2" />
      <DepartmentRoadmap category={category} companyId={companyId} loading={companyLoading} />
      {showGoals && (
        <DepartmentGoals department={department} ownerId={ownerId} ownerLoading={ownerLoading} />
      )}
    </div>
  );
};

export default DepartmentOverviewTopRow;
